import { partnerSharesTypes } from 'modules/partners/types/partnerSharesTypes';
import types from 'redux/actions/actionTypes';

export const updatePartnerShares = (decodedData: any, dispatch: any) => {
  const partnerShares = decodedData?.partnerActualShares;

  // Some operations don't increment or decrement the shares of the partners
  if (partnerShares) {
    dispatch({
      type: types.UPDATE_PARTNER_SHARES,
      partnerShares,
      sharesType: partnerSharesTypes.ACTUAL,
    });
  }
};
